import './helpers.js';
import './config.js';
import { b as registerComponent, u as use } from './plugins-9f2bbcd0.js';
import './Icon-f41e59e1.js';
import './FormElementMixin-26234baf.js';
import './Input-150c3e00.js';
import './MatchMediaMixin-a7a85be9.js';
import './trapFocus-25a621e6.js';
import './DropdownItem-2dd066e3.js';
import './Field-35159b1a.js';
import './Select-c72fe9d4.js';
import { _ as __vue_component__ } from './Datepicker-72aa84f3.js';
export { _ as ODatepicker } from './Datepicker-72aa84f3.js';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, __vue_component__);
  }

};
use(Plugin);

export default Plugin;
